var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import styled from "styled-components";
import { Flex } from "../Flex";
const StyledItem = styled(Flex)(({ interactive, onClick, selected, theme: { sizes, colors: { listColors }, }, }) => (Object.assign(Object.assign({}, (onClick && interactive
    ? {
        "&:hover": {
            background: selected ? listColors.itemSelectedBackground : listColors.itemHoverBackground,
            color: selected ? listColors.itemSelectedText : listColors.itemHoverText,
        },
        cursor: "pointer",
    }
    : {})), { backgroundColor: selected ? listColors.itemSelectedBackground : listColors.itemBackground, color: selected ? listColors.itemSelectedText : listColors.itemText, display: "flex", listStyle: "none", padding: sizes[2] })));
export const ListItem = forwardRef((_a, ref) => {
    var { label, children, interactive = true, leftIcon, rightIcon, selected } = _a, props = __rest(_a, ["label", "children", "interactive", "leftIcon", "rightIcon", "selected"]);
    return (React.createElement(StyledItem, Object.assign({ as: "li", interactive: interactive, selected: selected, ref: ref }, props),
        leftIcon,
        label,
        children,
        rightIcon));
});
